import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ReactiveFormsModule,
  FormControl,
  FormsModule,
  FormArray,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IttSectionDialogsComponent } from '../itt-section-dialogs.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { environment } from '@/app/environments/environment';
import { FileManagerComponent } from "@/app/components/shared/file-manager/file-manager.component";
import { ActivatedRoute, Router } from '@angular/router';
import { RfpLabelService } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/rfp-labels.service';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    RichTextEditorComponent,
    FileManagerComponent
  ],
  selector: 'app-commercial-submission',
  templateUrl: './commercial-submission.component.html',
  styleUrls: ['./commercial-submission.component.css'],
})
export class CommercialSubmissionComponent implements OnInit {
  base_path = environment.storageUrl;
  resetRichTextEditor = false;
  ittId: number;
  isRFPorRFQ: string;
  labels: any;

  constructor(
    private IttSectionDialogsComponent: IttSectionDialogsComponent,
    private toast: NgToastService,
    private TenderingService: TenderingService,
    private route: ActivatedRoute,
    private router: Router,
    private rfpLabelService: RfpLabelService
  ) { }
  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent
  @Output() commercialSubmissionDataEmitter: EventEmitter<any> =
    new EventEmitter<any>();

  @Input() tendererResponseData: any;

  oldPriceBreakDownFiles = [];
  deletedOldPriceBreakDownFilesIds = [];
  oldFinancialStabilityFiles = [];
  deletedOldFinancialStabilityFilesIds = [];
  oldPerformanceBondFiles = [];
  deletedOldPerformanceBondFilesIds = [];
  oldProofOfInsuranceFiles = [];
  deletedOldProofOfInsuranceFilesIds = [];

  form: FormGroup = new FormGroup({
    // title: new FormControl('', Validators.required),
    description_control: new FormControl(''),
    financial_stability_control: new FormControl(''),
    contractual_comments_control: new FormControl(''),
    priceBreakDownFileControl: new FormArray([]),
    financialStabilityFileControl: new FormArray([]),
    performanceBondFileControl: new FormArray([]),
    proofOfInsuranceFileControl: new FormArray([]),
  });

  closeModal = true;

  ngOnInit(): void {
    // Subscribe to route changes
    this.route.url.subscribe(() => {
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
      this.isRFPorRFQ = this.rfpLabelService.updateRFPorRFQFlag(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.ittId = this.TenderingService.getIttId();

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }
  }

  moveToPreviousStep() {
    this.IttSectionDialogsComponent.previousStep();
  }
  setContractualComments(content: string) {
    this.form.controls['contractual_comments_control'].setValue(content);
  }

  prepareDataToSubmit() {
    if (this.form.valid) {
      const formData = new FormData();

      formData.append('price_breakdown_title', this.form.value.title);
      formData.append(
        'price_breakdown_description',
        this.form.value.description_control
      );
      formData.append(
        'financial_stability_description',
        this.form.value.financial_stability_control
      );
      formData.append(
        'contractual_comments',
        this.form.value.contractual_comments_control
      );

      // Files handling Start
      this.addUploadedFiles(formData);
      this.addDeletedOldFilesIds(formData);
      // Files handling End

      return formData;
    }
  }

  // NOTE: when submitting form, add new files in data
  addUploadedFiles(submissionFormData) {
    this.form.value.priceBreakDownFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('commercial_price_breakdown_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.financialStabilityFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('financial_stability_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.performanceBondFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('performance_bond_guarantee_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.proofOfInsuranceFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('proof_of_insurance_attach[]', uploadedFile);
        }
      }
    );
  }

  // NOTE: on submit, append deleted files ids in data
  addDeletedOldFilesIds(submissionFormData) {
    if (this.deletedOldPriceBreakDownFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_old_commercial_price_breakdown_attach_ids',
        JSON.stringify(this.deletedOldPriceBreakDownFilesIds)
      );
    }
    if (this.deletedOldFinancialStabilityFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_old_financial_stability_attach_ids',
        JSON.stringify(this.deletedOldFinancialStabilityFilesIds)
      );
    }
    if (this.deletedOldPerformanceBondFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_old_performance_bond_guarantee_attach_ids',
        JSON.stringify(this.deletedOldPerformanceBondFilesIds)
      );
    }
    if (this.deletedOldProofOfInsuranceFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_old_proof_of_insurance_attach_ids',
        JSON.stringify(this.deletedOldProofOfInsuranceFilesIds)
      );
    }
  }

  moveToNextStep() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.toast.warning(
        'Please fill in all required fields.',
        'WARNING',
        4000
      );
      return;
    }
    const dataToSubmit = this.prepareDataToSubmit();
    this.TenderingService.addCommercialSubmission(
      dataToSubmit,
      this.ittId
    ).subscribe({
      next: (response) => {
        if (!response?.meta?.success) {
          return;
        }

        this.toast.success('Commercial Submission Done', 'SUCCESS');
        this.commercialSubmissionDataEmitter.emit(response?.data);
        this.IttSectionDialogsComponent.nextStep();
      },
      error: (error: any) => {
        console.error('Failed to submit:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }
  handleBack() {
    this.IttSectionDialogsComponent.previousStep();
  }

  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tendering Response Data is undefined');
      return;
    }

    this.form.patchValue({
      title: this.tendererResponseData?.priceBreakdownTitle ?? '',
      description_control:
        this.tendererResponseData?.priceBreakdownDescription ?? '',
      financial_stability_control:
        this.tendererResponseData?.financialStabilityDescription ?? '',
      contractual_comments_control:
        this.tendererResponseData?.contractualComments ?? '',
    });

    this.oldPriceBreakDownFiles =
      this.tendererResponseData?.commercialPriceBreakdownAttachments ?? [];
    this.oldPerformanceBondFiles =
      this.tendererResponseData?.performanceBondGuaranteeAttachments ?? [];
    this.oldFinancialStabilityFiles =
      this.tendererResponseData?.financialStabilityAttachments ?? [];
    this.oldProofOfInsuranceFiles =
      this.tendererResponseData?.proofOfInsuranceAttachments ?? [];
  }

  /**
   * Handling File Operations - START
   */
  // Uploading/Deleting new files for site preparation
  handleNewFiles(filesData: {
    files: File[],
    controlName: string,
    isEmpty: boolean,
  }) {
    switch (filesData.controlName) {
      case 'priceBreakDownFileControl': {
        const fileArray = this.form.get('priceBreakDownFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'financialStabilityFileControl': {
        const fileArray = this.form.get('financialStabilityFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'performanceBondFileControl': {
        const fileArray = this.form.get('performanceBondFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'proofOfInsuranceFileControl': {
        const fileArray = this.form.get('proofOfInsuranceFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      default:
        break;
    }
  }

  handleDeletedOldFiles(OldFileData: any) {
    switch (OldFileData.controlName) {
      case 'priceBreakDownFileControl': {
        this.deletedOldPriceBreakDownFilesIds.push(OldFileData?.file?.id);
        this.oldPriceBreakDownFiles = this.oldPriceBreakDownFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'financialStabilityFileControl': {
        this.deletedOldFinancialStabilityFilesIds.push(OldFileData?.file?.id);
        this.oldFinancialStabilityFiles = this.oldFinancialStabilityFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'performanceBondFileControl': {
        this.deletedOldPerformanceBondFilesIds.push(OldFileData?.file?.id);
        this.oldPerformanceBondFiles = this.oldPerformanceBondFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'proofOfInsuranceFileControl': {
        this.deletedOldProofOfInsuranceFilesIds.push(OldFileData?.file?.id);
        this.oldProofOfInsuranceFiles = this.oldProofOfInsuranceFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }

      default:
        break;
    }
  }
  /**
   * Handling File Operations - END
   */

}
